<template>
    <div class="flex flex-row items-end">
        <Select
            label="Copy content from"
            name="copy_content_from"
            v-model.number="variantId"
            class="my-2"
            :options="variants.length ? variants : []"
            placeholder="Select a translation"
        ></Select>
        <div>
            <Btn
                :disabled="processing"
                class="mb-2 ml-2"
                type="button"
                @click="createTranslation"
                content="Confirm"
            ></Btn>
        </div>
    </div>
</template>

<script>
import Select from "./Select";
import Btn from "./Btn";
import siteLanguage from '../../config/siteLanguage'
export default {
    name: "Translator",
    components: {Btn, Select},
    props: {
        baseDocument: null,
        documentType: null,
        language: {
            required: true,
            default: () => {
                return {
                    id: siteLanguage.language.ENGLISH,
                    iso: siteLanguage.iso.ENGLISH,
                    slug: "en",
                };
            }
        }
    },
    data(){
        return {
            baseModel: JSON.parse(this.baseDocument),
            variantId: null,
            variants: [],
            processing: false
        };
    },
    mounted(){
        this.getVariants();
    },
    methods: {
        async getVariants(){
            const {data} = await axios.get(route('variants.show', {
                document: this.documentType,
                id: this.baseModel.id
            }))
            .catch(err => err.response || err);
            this.variants = data;
        },
        async createTranslation(){
            this.processing = true;
            const {data} = await axios.post(route('variants.store', {
                document: this.documentType,
                id: this.variantId,
                language: this.language.id
            }))
            .catch(err => {
                this.$notify({
                    group: "formError",
                    title: "Problem duplicating",
                    text: "Please let a developer know about this issue",
                });
                console.error(err);
            });
            this.processing = false;

            try {
                const url = new URL(data);

                this.$notify({
                    group: "helper",
                    title: "Duplicating...",
                    text: "You'll be redirected in a couple of seconds",
                });
                setTimeout(() => window.location.href = url.href, 200)
            }
            catch (e) {
                this.$notify({
                    group: "formError",
                    title: "Problem duplicating",
                    text: "Please let a developer know about this issue",
                });
                console.error(e);
            }
        }
    },
    computed: {
        selectedVariant(){
            return this.variants.find(variant => variant.id === this.variant)
        }
    }
}
</script>

<style scoped>

</style>
